// extracted by mini-css-extract-plugin
module.exports = {"contactHeadline":"Contacts_contactHeadline__86T9u","contact":"Contacts_contact__Nr1au","smItem":"Contacts_smItem__0a5aQ"};